module.exports = __webpack_public_path__ + "static/media/29BDOS27.1b18f967.jpg";